






























import { Component, Prop, Vue, Watch, Mixins, Emit } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";

@Component({
  components: {}
})
export default class ScreensPagination extends Vue {
  $refs!: {
    root: HTMLElement
  }
  @Prop({ default: () => { return [] } }) hideOnScreens!: number[];
  @Prop({ default: 0 }) numberOfScreens!: number;
  @Prop({ default: 0 }) activeScreenNumber!: number;
  @Prop({ default: [] }) names!: string[];
  @Getter('pageBehindAWindow') pageBehindAWindow!: boolean;
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  nextScreenName = "";
  prevScreenName = "";

  @Watch("activeScreenNumber")
  onActiveScreenNumberChange(newValue: number, prevValue: number) {
    this.prevScreenName = (prevValue > 0 && this.names[prevValue]) ? this.names[prevValue] : "";
    this.nextScreenName = (newValue > 0 && this.names[newValue]) ? this.names[newValue] : "";

    if (this.hideOnScreens.includes(newValue)) {
      anime({
        targets: this.$refs.root,
        opacity: 0,
        duration: 200,
        easing: 'linear'
      });
    } else {
      anime({
        targets: this.$refs.root,
        opacity: 1,
        duration: 200,
        easing: 'linear'
      });
    }

    this.$nextTick(() => {
      let pLetters = this.$refs.root.querySelectorAll<HTMLElement>(".prev span");
      let nLetters = this.$refs.root.querySelectorAll<HTMLElement>(".next span");
      let arrow = this.$refs.root.querySelector<HTMLElement>(".arrow");

      anime({
        targets: pLetters,
        top: ["0%", "-105%"],
        duration: 550,
        easing: 'easeOutQuad',
        delay: (el, i) => { return 10 * i },
        complete: () => {
        }
      });

      anime({
        targets: nLetters,
        top: ["105%", "0%"],
        duration: 550,
        easing: 'easeOutQuad',
        delay: (el, i) => { return 10 * i },
        complete: () => {
        }
      });
    });
  }

  @Emit("nextScreen")
  next() { }
}
